<template>
  <Modal v-model="showModal" :mask-closable="false" width="1200px">
    <div slot="header">{{showLang('com.edit.lamp.info')}}</div>
    <Form ref="form" :model="form" :rules="rules" :label-width="130">
      <FormItem prop="name" :label="showLang('com.tab.title')" style="margin-right: 15px">
        <div class="flex-row">
          <Input type="text" v-model="form.name" :placeholder="showLang('com.tab.title')" style="width: 200px; margin-right: 20px;"></Input>
          所在分区
          <Select :placeholder="showLang('save.select')" v-model="form.groupId" style="width: 150px; margin-left: 10px; margin-right: 36px;">
            <template v-for="(item, idx) in allGroups">
              <Option :value="item.id" :key="idx">{{item.name}}</Option>
            </template>
          </Select>
          分组
          <Select :placeholder="showLang('save.select')" v-model="form.lightGroupId" style="width: 150px; margin-left: 10px; margin-right: 25px;">
            <template v-for="(item, idx) in args.groups">
              <Option :value="item.id" :key="idx">{{item.name}}</Option>
            </template>
          </Select>
          应用类型
          <Select :placeholder="showLang('save.select')" v-model="form.useType" style="width: 150px; margin-left: 10px;">
            <template v-for="(item, idx) in args.useTypes">
              <Option :value="item.id" :key="idx">{{item.name}}</Option>
            </template>
          </Select>
        </div>
      </FormItem>
      <FormItem prop="stationId" label="设备类型" style="margin-right: 15px">
        <div class="flex-row">
          <Select :placeholder="showLang('save.select')" v-model="form.deviceType" style="width: 200px; margin-right: 33px;">
            <Option v-for="(s, idx) in args.deviceTypes" :key="idx" :value="s.code">{{s.name}}</Option>
          </Select>
          通信ID
          <Input type="text" v-model="form.code" placeholder="请输入通信ID" style="width: 150px; margin-right: 10px; margin-left: 10px;"></Input>
          <template v-if="args.gateways.length > 0">
            关联网关
            <Select :placeholder="showLang('save.select')" v-model="form.gatewayId" style="width: 150px; margin-left: 10px; margin-right: 10px;">
              <Option value="00000000-0000-0000-0000-000000000000">{{showLang('com.state.not')}}</Option>
              <template v-for="(s, idx) in args.gateways">
                <Option :value="s.id" :key="idx">{{s.name}}</Option>
              </template>
            </Select>
            上行通道号
            <Input type="number" v-model="form.channel" placeholder="请输入通信ID" style="width: 150px; margin-left: 10px;"></Input>
          </template>
        </div>
      </FormItem>
      <FormItem prop="env" :label="showLang('com.state.is.v.police')" style="margin-right: 15px">
        <div class="flex-row">
          <i-switch v-model="form.voltageAlarm" size="large" true-color="green" false-color="red" style="margin-right:10px;width:56px">
            <span slot="open">{{showLang('com.state.enable')}}</span>
            <span slot="close">{{showLang('com.state.disable')}}</span>
          </i-switch>
          <Input type="number" v-model="form.voltageLower" style="width: 250px; margin: 0 5px;"><span slot="prepend">{{showLang('com.data.lower.val')}}</span><span slot="append">V</span></Input>
          <Input type="number" v-model="form.voltageUpper" style="width: 250px; margin: 0 5px;"><span slot="prepend">{{showLang('com.data.upper.val')}}</span><span slot="append">V</span></Input>
        </div>
      </FormItem>
      <FormItem prop="ent" :label="showLang('com.state.is.t.police')" style="margin-right: 15px">
        <div class="flex-row">
          <i-switch v-model="form.tempAlarm" size="large" true-color="green" false-color="red" style="margin-right:10px;width:56px">
            <span slot="open">{{showLang('com.state.enable')}}</span>
            <span slot="close">{{showLang('com.state.disable')}}</span>
          </i-switch>
          <Input type="number" v-model="form.tempLevel1" style="width: 250px; margin: 0 5px;"><span slot="prepend">{{showLang('com.lighting.T.min')}}</span><span slot="append">℃</span></Input>
          <Input type="number" v-model="form.tempLevel2" style="width: 250px; margin: 0 5px;"><span slot="prepend">{{showLang('com.lighting.T.max')}}</span><span slot="append">℃</span></Input>
        </div>
      </FormItem>
      <!-- <FormItem prop="engyro" :label="showLang('com.state.is.gyro.police')" style="margin-right: 15px">
        <i-switch v-model="form.gyroAlarm" size="large" true-color="green" false-color="red" style="margin-right:10px;width:56px">
          <span slot="open">{{showLang('com.state.enable')}}</span>
          <span slot="close">{{showLang('com.state.disable')}}</span>
        </i-switch>
      </FormItem> -->
      <FormItem prop="buildDate" :label="showLang('com.date.installation')">
        <DatePicker ref="buildDate" type="date" format="yyyy-MM-dd" v-model="form.buildDate" :placeholder="showLang('com.date.select.installation')" :editable="false"></DatePicker>
      </FormItem>
      <template v-for="n in 2">
        <FormItem :key="`${n}-1`" prop="en1" :label="`${n}路控制参数`" style="margin-right: 15px">
          <div class="flex-row">
            <i-switch v-model="form[`enable${n}`]" size="large" true-color="green" false-color="red" style="margin-right:10px;width:56px">
              <span slot="open">{{showLang('com.state.enable')}}</span>
              <span slot="close">{{showLang('com.state.disable')}}</span>
            </i-switch>
            <Input type="number" v-model="form[`before${n}`]" style="width: 200px; margin-right:10px">
              <span slot="prepend">{{showLang('com.import.cn.lamp.p')}}</span>
              <span slot="append">W</span>
            </Input>
            <Input type="number" v-model="form[`after${n}`]" style="width: 200px; margin-right:10px">
              <span slot="prepend">{{showLang('com.lighting.pr1')}}</span>
              <span slot="append">W</span>
            </Input>
            <Input type="number" v-model="form[`count${n}`]" style="width: 150px; margin-right:10px"><span slot="prepend">{{showLang('com.import.cn.lamp.num')}}</span></Input>
            <Input type="number" v-model="form[`adjust${n}`]" style="width: 200px; margin-right:10px"><span slot="prepend">{{showLang('com.import.cn.lamp.pc')}}</span></Input>
          </div>
        </FormItem>
        <FormItem :key="`${n}-2`" prop="en1" :label="`${n}路控制方式`" style="margin-right: 15px">
          <div class="flex-row">
            <Select :placeholder="showLang('save.select')" v-model="form[`mode${n}`]" style="width: 200px; margin-right: 10px;">
              <Option v-for="(s, idx) in args.modes" :key="idx" :value="s.id">{{s.name}}</Option>
            </Select>
            关联计时日表：
            <Select :placeholder="showLang('save.select')" v-model="form[`planId1${n}`]" style="width: 200px; margin-right: 10px;">
              <Option v-for="(s, idx) in args.plan1s" :key="idx" :value="s.id">{{s.name}}</Option>
            </Select>
            关联准时日表：
            <Select :placeholder="showLang('save.select')" v-model="form[`planId2${n}`]" style="width: 200px; margin-right: 10px;">
              <Option v-for="(s, idx) in args.plan2s" :key="idx" :value="s.id">{{s.name}}</Option>
            </Select>
          </div>
        </FormItem>
        <FormItem :key="`${n}-3`" prop="en1" :label="`${n}路电流报警`" style="margin-right: 15px">
          <div class="flex-row">
            <i-switch v-model="form[`currentAlarm${n}`]" size="large" true-color="green" false-color="red" style="margin-right:10px;width:56px">
              <span slot="open">{{showLang('com.state.enable')}}</span>
              <span slot="close">{{showLang('com.state.disable')}}</span>
            </i-switch>
            <Input type="number" v-model="form[`currentLower${n}`]" style="width: 250px; margin: 0 5px;">
              <span slot="prepend">{{showLang('com.data.lower.val')}}</span>
              <span slot="append">A</span>
            </Input>
            <Input type="number" v-model="form[`currentUpper${n}`]" style="width: 250px; margin: 0 5px;">
              <span slot="prepend">{{showLang('com.data.upper.val')}}</span>
              <span slot="append">A</span>
            </Input>
          </div>
        </FormItem>
        <FormItem :key="`${n}-4`" prop="en1" :label="`${n}路漏电报警`" style="margin-right: 15px">
          <div class="flex-row">
            漏电电流报警
            <i-switch v-model="form[`leakageCurrentAlarm${n}`]" size="large" true-color="green" false-color="red" style="margin:10px;width:56px">
              <span slot="open">{{showLang('com.state.enable')}}</span>
              <span slot="close">{{showLang('com.state.disable')}}</span>
            </i-switch>
            <Input type="number" v-model="form[`leakageCurrentUpper${n}`]" style="width: 250px; margin: 0 10px;">
              <span slot="prepend">漏电电流阈值</span>
              <span slot="append">mA</span>
            </Input>
            漏电电压报警
            <i-switch v-model="form[`leakageVoltageAlarm${n}`]" size="large" true-color="green" false-color="red" style="margin:10px;width:56px">
              <span slot="open">{{showLang('com.state.enable')}}</span>
              <span slot="close">{{showLang('com.state.disable')}}</span>
            </i-switch>
            <Input type="number" v-model="form[`leakageVoltageUpper${n}`]" style="width: 250px; margin: 0 10px;">
              <span slot="prepend">漏电电压阈值</span>
              <span slot="append">V</span>
            </Input>
          </div>
        </FormItem>
      </template>
    </Form>
    <div slot="footer">
      <Button style="margin-right: 8px" @click="cancel">{{showLang('com.op.cancel')}}</Button>
      <Button type="primary" :loading="loading" @click="ok">{{showLang('com.op.save')}}</Button>
    </div>
  </Modal>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'ModalLampEdit',
  components: {
  },
  model: {
    prop: 'value',
    event: 'showChanged'
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default() { return {}; }
    },
    args: {
      type: Object,
      default() { return {}; }
    },
  },
  data() {
    return {
      showModal: this.value,
      loading: false,
      isAdd: false,
      form: {
        id: 0,
        lightGroupId: 0, //所属灯控分组ID
        gatewayId: '', //所在网关ID
        groupId: 0, //所在分区ID
        useType: 101, //应用类型
        deviceType: 0, //设备类型
        code: '',
        name: '',
        channel: 6, //有网关的前提下，与网关的通信信道号
        voltageAlarm: false, //是否电压报警
        voltageLower: 80, //电压报警下限
        voltageUpper: 280, //电压报警上限
        tempAlarm: false, //是否温度报警
        tempLevel1: 50, //温度一级报警阈值
        tempLevel2: 80, //温度二级报警阈值
        gyroAlarm: false, //是否倾斜报警
        buildDate: "2024-04-01",
        enable1: true, //通道是否启用
        before1: 250, //通道改造前功率
        after1: 100, //通道当前功率
        count1: 1, //通道光源数量
        adjust1: 1, //通道测量系数
        planId11: 0, //通道关联计时日表ID，
        planId21: 0, //通道关联准时日表ID，
        mode1: 0, //通道控制方式
        currentAlarm1: false, //通道是否电流报警
        currentLower1: 0.3, //通道电流报警下限
        currentUpper1: 10, //通道电流报警上限
        leakageCurrentAlarm1: false, //通道是否漏电电流报警
        leakageCurrentUpper1: 500, //漏电电流报警阈值
        leakageVoltageAlarm1: false, //通道是否漏电电压报警
        leakageVoltageUpper1: 100, //漏电电压报警阈值
        enable2: true, //通道是否启用
        before2: 250, //通道改造前功率
        after2: 100, //通道当前功率
        count2: 1, //通道光源数量
        adjust2: 1, //通道测量系数
        planId12: 0, //通道关联计时日表ID，
        planId22: 0, //通道关联准时日表ID，
        mode2: 0, //通道控制方式
        currentAlarm2: false, //通道是否电流报警
        currentLower2: 0.3, //通道电流报警下限
        currentUpper2: 10, //通道电流报警上限
        leakageCurrentAlarm2: false, //通道是否漏电电流报警
        leakageCurrentUpper2: 500, //漏电电流报警阈值
        leakageVoltageAlarm2: false, //通道是否漏电电压报警
        leakageVoltageUpper2: 100, //漏电电压报警阈值
      },
      rules: {
        // name: { required: true, type: 'string', max: 20, message: '名称不能为空且长度必须少于20个字符', trigger: 'blur' },
        // topCode: { required: true, type: 'string', max: 20, message: '编码不能为空且长度必须少于20个字符', trigger: 'blur' },
        // location: { required: false, type: 'string', max: 50, message: '安装位置长度必须少于50个字符', trigger: 'blur' },
        // monitorCode: { required: true, type: 'string', max: 20, message: '编码不能为空且长度必须少于20个字符', trigger: 'blur' },
      },
    }
  },
  watch: {
    value(newVal) {
      this.showModal = newVal;
      if (newVal) {
        // console.log('modal level edit mounted', this.item)
        this.isAdd = this.item.isAdd;
        if (!this.isAdd) {
          for(let key in this.form){
            // console.log('edit form', key, this.item.data[key])
            this.form[key] = this.item.data[key];
          }
        } else {
          this.form.id = '';
          this.form.lightGroupId = 0;
          this.form.name = '';
          this.form.code = '';
          this.form.gatewayId = '00000000-0000-0000-0000-000000000000';
          this.form.groupId = 0;
          this.form.useType = 101;
          this.form.deviceType = 0;
          this.form.channel = 6;
          this.form.voltageAlarm = true;
          this.form.voltageLower = 80;
          this.form.voltageUpper = 280;
          this.form.tempAlarm = true;
          this.form.tempLevel1 = 50;
          this.form.tempLevel2 = 80;
          this.form.gyroAlarm = false;
          this.form.buildDate = new Date().format('yyyy-MM-dd');
          this.form.enable1 = true; //通道是否启用
          this.form.before1 = 250; //通道改造前功率
          this.form.after1 = 100; //通道当前功率
          this.form.count1 = 1; //通道光源数量
          this.form.adjust1 = 1; //通道测量系数
          this.form.planId11 = 0; //通道关联计时日表ID，
          this.form.planId21 = 0; //通道关联准时日表ID，
          this.form.mode1 = 0; //通道控制方式
          this.form.currentAlarm1 = true; //通道是否电流报警
          this.form.currentLower1 = 0.3; //通道电流报警下限
          this.form.currentUpper1 = 10; //通道电流报警上限
          this.form.leakageCurrentAlarm1 = true; //通道是否漏电电流报警
          this.form.leakageCurrentUpper1 = 500; //漏电电流报警阈值
          this.form.leakageVoltageAlarm1 = true; //通道是否漏电电压报警
          this.form.leakageVoltageUpper1 = 100; //漏电电压报警阈值
          this.form.enable2 = true; //通道是否启用
          this.form.before2 = 250; //通道改造前功率
          this.form.after2 = 100; //通道当前功率
          this.form.count2 = 1; //通道光源数量
          this.form.adjust2 = 1; //通道测量系数
          this.form.planId12 = 0; //通道关联计时日表ID，
          this.form.planId22 = 0; //通道关联准时日表ID，
          this.form.mode2 = 0; //通道控制方式
          this.form.currentAlarm2 = true; //通道是否电流报警
          this.form.currentLower2 = 0.3; //通道电流报警下限
          this.form.currentUpper2 = 10; //通道电流报警上限
          this.form.leakageCurrentAlarm2 = true; //通道是否漏电电流报警
          this.form.leakageCurrentUpper2 = 500; //漏电电流报警阈值
          this.form.leakageVoltageAlarm2 = true; //通道是否漏电电压报警
          this.form.leakageVoltageUpper2 = 100; //漏电电压报警阈值
        }
      }
    },
    showModal(val) {
      this.$emit('showChanged', val);
    },
    // 'form.stationId'(){
    //   this.form.paramId = 0;
    // },
  },
  computed: {
    ...mapState('common', ['newLightTypes', 'deviceTypes', 'productCodes', 'bigTypes', 'smallTypes']),
    ...mapGetters('auth', ['showLang']),
    ...mapState('group', ['groupTreeSelectedNode']),
    allGroups: function(){
      // console.log('all groups', this.groupTreeSelectedNode)
      if(!this.groupTreeSelectedNode.children)return[];
      let grps = [];
      if(this.groupTreeSelectedNode.id > 0){
        grps.push({id: this.groupTreeSelectedNode.id, name: this.groupTreeSelectedNode.title});
      }
      for(let node of this.groupTreeSelectedNode.children){
        this.getChildGroups(grps, node);
      }
      return grps;
    },
  },
  mounted: function () {
    // this.form.content.nm1=this.showLang('com.lamp.host');
    // this.form.content.nm2=this.showLang('com.lamp.assist');
    // this.form.content.nm3=this.showLang('com.lamp.assist');
    // this.form.content.nm4=this.showLang('com.lamp.assist');
    // this.form.content.tp1=this.showLang('com.state.default');
    // this.form.content.tp2=this.showLang('com.state.default');
    // this.form.content.tp3=this.showLang('com.state.default');
    // this.form.content.tp4=this.showLang('com.state.default');
    // console.log('modal level edit mounted', this.alarmTypes, this.alarmGroupList)
  },
  methods: {
    getChildGroups: function(list, node){
      list.push({id: node.id, name: node.title});
      for(let n of node.children){
        this.getChildGroups(list, n);
      }
    },
    ok: async function () {
      if (this.form.name.trim().length == 0) {
        this.$Message.warning(this.showLang('save.name'));
        return;
      }
      if (this.form.groupId <= 0) {
        this.$Message.warning("请选择所在分区");
        return;
      }
      if (this.form.deviceType <= 0) {
        this.$Message.warning("请选择设备类型");
        return;
      }
      if (this.form.code.trim().length == 0) {
        this.$Message.warning("请输入通信ID");
        return;
      }
      if(!this.form.enable1 && !this.form.enable2){
        this.$Message.warning('至少启用一个通道');
        return;
      }
      this.$axios.post(`device/light/SaveLampConfig`, this.form).then(res => {
        if (res.code != 0) {
          // this.$Message.error(res.data);
        } else {
          this.$Message.info('保存成功');
          this.showModal = false;
          this.$emit('saved', { isAdd: this.isAdd, data: res.data });
        }
      })
    },
    cancel() {
      this.showModal = false;
      // this.$refs.form.resetFields();
    },
  }
}
</script>
<style scoped>
.form-item-group {
  border: solid 1px rgba(129, 124, 124, 0.377);
  border-radius: 12px;
  margin-bottom: 15px;
}
.group-header {
  /* border: solid 1px blue; */
  background-color: rgba(221, 216, 216, 0.808);
  margin-bottom: 15px;
  height: 35px;
  border-radius: 12px 12px 0 0;
  line-height: 35px;
  font-weight: bold;
  padding: 0 10px;
}
.demo-drawer-footer {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
.edit-form-item{
  border: solid 1px red;
  margin-top: 5px;
}
.form {
  height: calc(100% - 54px);
  overflow: auto;
}
.readonly {
  background: #eee;
}
</style>